import React from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { LotusIcon } from './icons/AlchemyIcons';
import { ExternalLink } from './icons/CustomDashboardIcons';

export const DashboardAnnouncementCards = ({ announcements = [] }) => {
  const active = (announcements || []).filter(a => a && a.active !== false);
  if (active.length <= 1) return null; // primary announcement handled by the top section

  const extra = active.slice(1, 3);

  return (
    <div className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="dashboard-announcement-cards">
      {extra.map((a) => {
        const link = (a.zoom_link || (Array.isArray(a.links) && a.links[0]?.url) || '').trim();
        const label = (Array.isArray(a.links) && a.links[0]?.label) || 'Open link';

        return (
          <div
            key={a.id}
            className="rounded-2xl border border-sky-400/50 bg-sky-50/90 text-slate-900 p-5 shadow-sm"
            data-testid={`announcement-card-${a.id}`}
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-xl bg-sky-600 text-white flex items-center justify-center shadow-md shadow-sky-500/20">
                  <LotusIcon className="w-5 h-5" />
                </div>
                <div>
                  <div className="flex items-center gap-2">
                    <h3 className="text-base font-semibold" data-testid={`announcement-title-${a.id}`}>{a.title || 'Announcement'}</h3>
                    <Badge className="bg-sky-600/10 text-sky-700 border-sky-700/20" data-testid={`announcement-badge-${a.id}`}>Update</Badge>
                  </div>
                  {a.message && (
                    <p className="text-sm text-slate-700 mt-1" data-testid={`announcement-message-${a.id}`}>{a.message}</p>
                  )}
                </div>
              </div>
            </div>

            {link && (
              <div className="mt-4">
                <a href={link} target="_blank" rel="noopener noreferrer" data-testid={`announcement-link-${a.id}`}>
                  <Button
                    size="sm"
                    className="bg-sky-600 hover:bg-sky-500 text-white font-semibold px-3 py-2 rounded-lg"
                    data-testid={`announcement-link-button-${a.id}`}
                  >
                    {label}
                    <ExternalLink className="ml-2 w-4 h-4" />
                  </Button>
                </a>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
